<template>
    <component
        v-if="visible"
        :is="componentName"
        class="quick-save-save-to-workspace"
        :service="service"
        append-to-body
    />
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { SavePatentToWorkspace, SavePaperToWorkspace } from 'patsnap-biz'
import '@patsnap-biz/save-to-workspace-v2/lib/style';
import { useSaveService } from '../composables/use-save-service';
import type { IServiceProps } from '../types/batch-save';
import { EBatchSaveType } from '../types/batch-save';

import _ from 'lodash-es';

const props = defineProps<{
    saveData: IServiceProps
}>()

const { service } = useSaveService(props.saveData)
service.init();

const componentName = computed(() => {
    const type = _.get(props.saveData, 'type')
    if (type === EBatchSaveType.PATENT) {
        return SavePatentToWorkspace;
    }
    if (type === EBatchSaveType.PAPER) {
        return SavePaperToWorkspace;
    }
    return ''
})

const visible = computed(() => {
    return !_.isEmpty(service) && componentName.value
})
</script>
<style lang="scss">
@import "../assets/overwrite-save-to-workspace.scss";
</style>
